let loadMoreBtn;
let loader;
let responseContainer;
let isLoading;
let areAllPostsLoaded = false;
let previousCategory;
let currentCategory;
const scrollDetectionOffset = 150;

export default () => {
    loadMoreBtn = document.querySelector('#posts-load-more');
    loader = document.querySelector('#posts-grid-loader');
    responseContainer = document.querySelector('#posts-container');
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', () => {
            loadMore();
        })
    }

    if (responseContainer) {
        window.addEventListener('scroll', handleWindowScrollEvent)
    } else {
        window.removeEventListener('scroll', handleWindowScrollEvent)
    }
}

function handleWindowScrollEvent() {
    if (!isLoading && window.scrollY - responseContainer.clientHeight > -scrollDetectionOffset) {
        loadMore();
    }
}

function loadMore() {
    if (responseContainer) {
        previousCategory = currentCategory;
        currentCategory = responseContainer.dataset.currentCategory??'all';
        let postsPerPage = parseInt(responseContainer.dataset.postsPerPage);

        if (previousCategory !== currentCategory) {
            areAllPostsLoaded = false;
        }

        if (!isLoading && !areAllPostsLoaded) {
            isLoading = true;

            let paged = responseContainer.dataset.paged;
            paged = paged ? parseInt(paged) + 1 : 1;

            if (loader) {
                loader.classList.add('show');
            }

            getData(currentCategory, postsPerPage, paged).then(data => {
                if (data) {
                    responseContainer.innerHTML += data;
                    responseContainer.dataset.paged = paged.toString();
                } else {
                    areAllPostsLoaded = true;
                }

                loader.classList.remove('show');
                isLoading = false;
            });
        }
    }

}

function getData(category, postsPerPage, paged) {
    return fetch(ajaxConfig.ajax_url, {
        method: 'POST', // POST
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: new URLSearchParams({
            category,
            posts_per_page: postsPerPage,
            paged,
            action: 'load_more_posts',
        })
    })

        .then(res => {
            if (res.status === 200) {
                return res.text()
            } else {
                return false;
            }
        })
        .catch(e => {
            areAllPostsLoaded = true;
        })
}
